import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ViewportProps } from 'react-map-gl';
import {
  EventOffering_PassEdge as EventOffering,
  FacilityOffering,
} from '@pass-frontend/data-access/common/edge';
import { OFFERINGS_SLICE_NAME, OfferingsState } from './offerings.types';

export const initialState: OfferingsState = {
  chosenGymID: null,
  chosenSocialEventID: null,
  chosenPin: null,
  mobileFilterDrawerForGymsIsOpen: false,
  mobileFilterDrawerForSocialEventsIsOpen: false,
  mapIsVisible: false,
  viewport: {},
  viewportIsSearchArea: false,
  isSocialEventsTriggeredFromFitness: false,
  userPreferenceOfMap: true,
};

export const offeringsSlice = createSlice({
  name: OFFERINGS_SLICE_NAME,
  initialState,
  reducers: {
    clearChosenGym(state) {
      state.chosenGymID = null;
      state.chosenPin = null;
    },
    updateChosenGymID(
      state,
      action: PayloadAction<FacilityOffering['facilityId']>,
    ) {
      state.chosenGymID = action.payload || null;
    },
    clearChosenSocialEvent(state) {
      state.chosenSocialEventID = null;
    },
    updateChosenSocialEventID(
      state,
      action: PayloadAction<EventOffering['eventId']>,
    ) {
      state.chosenSocialEventID = action.payload || null;
    },
    updateChosenPin(
      state,
      action: PayloadAction<FacilityOffering['facilityId']>,
    ) {
      state.chosenPin = action.payload;
    },

    // replace filter context provider
    toggleVisibilityOfMobileFilterDrawerForGyms(state) {
      state.mobileFilterDrawerForGymsIsOpen =
        !state.mobileFilterDrawerForGymsIsOpen;
    },
    updateVisibilityOfMobileFilterDrawerForGyms(
      state,
      action: PayloadAction<boolean>,
    ) {
      state.mobileFilterDrawerForGymsIsOpen = action.payload || false;
    },
    toggleVisibiltyOfMobileFilterDrawerForSocialEvents(state) {
      state.mobileFilterDrawerForSocialEventsIsOpen =
        !state.mobileFilterDrawerForSocialEventsIsOpen;
    },
    updateVisibilityOfMobileFilterDrawerForSocialEvents(
      state,
      action: PayloadAction<boolean>,
    ) {
      state.mobileFilterDrawerForSocialEventsIsOpen = action.payload || false;
    },

    // save user preference for map visibility
    updateUserPreferenceOfMap(state, action: PayloadAction<boolean>) {
      state.userPreferenceOfMap = action.payload;
    },

    // replace map visibility context provider
    toggleVisibilityOfMap(state) {
      state.mapIsVisible = !state.mapIsVisible;
    },
    updateVisibilityOfMap(state, action: PayloadAction<boolean>) {
      state.mapIsVisible = action.payload || false;
    },
    // map view port manipulation
    updateMapViewport(state, action: PayloadAction<ViewportProps>) {
      state.viewport = action.payload;
    },
    updateViewportIsSearchArea(state, action: PayloadAction<boolean>) {
      state.viewportIsSearchArea = action.payload;
    },
    updateIsSocialEventTriggeredFromFitness(
      state,
      action: PayloadAction<boolean>,
    ) {
      state.isSocialEventsTriggeredFromFitness = action.payload || false;
    },
  },
});

export const reducer = offeringsSlice.reducer;
export const Actions = offeringsSlice.actions;
